import Axios from "axios";
import axiosClient from "./axiosClient";

const BaseURL: string = process.env.REACT_APP_API_URL ?? "";

async function LogService(logRequest: LogRequest) {
  try {
    await axiosClient.post(`/log/message`, logRequest);
  } catch (error) {
    console.error("Error logging request:", error);
  }
}

export default LogService;
